angular
    .module('app')
    .component('subjectsAdd', {
        templateUrl: '/templates/pages/subjects/subjectsAdd/subjectsAdd.html',
        controller: 'SubjectsAddController',
        controllerAs: 'vm',
    });